import React, { useContext, useEffect, useMemo, useRef } from "react";
import { Input } from "../../../Helpers/Input/Input";
import trans from "../../../../utils";
import Button from "../../../Helpers/Button/Button";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import { popupcontext } from "../../../../context/Popupscontext";
import { toast } from "react-toastify";

/* =========================
   Single Logo Component
========================= */
function Logo({ label, InputId, UploadId, addPOI, value, Logovalue }) {
	const { isEditing } = useContext(popupcontext);
	const objectUrlRef = useRef(null);

	/* ---------- SAFE logo src ---------- */
	const logoSrc = useMemo(() => {
		// cleanup previous object URL
		if (objectUrlRef.current) {
			URL.revokeObjectURL(objectUrlRef.current);
			objectUrlRef.current = null;
		}

		if (!Logovalue) return null;

		// backend image (edit mode)
		if (typeof Logovalue === "string") {
			return Logovalue;
		}

		// AntD Upload file
		if (
			Array.isArray(Logovalue) &&
			Logovalue[0]?.originFileObj instanceof Blob
		) {
			const url = URL.createObjectURL(Logovalue[0].originFileObj);
			objectUrlRef.current = url;
			return url;
		}

		return null;
	}, [Logovalue]);

	/* ---------- cleanup on unmount ---------- */
	useEffect(() => {
		return () => {
			if (objectUrlRef.current) {
				URL.revokeObjectURL(objectUrlRef.current);
			}
		};
	}, []);

	return (
		<div className="row">
			{/* Label input */}
			<div className="col-lg-6">
				<Input
					title={trans(`${label} Name`)}
					type="text"
					placeholder={trans(`Enter ${label} label`)}
					id={InputId}
					name={InputId}
					formstyle="form-input"
					onBlur={addPOI.handleBlur}
					onChange={addPOI.handleChange}
					value={value || ""}
				/>
			</div>

			{/* Upload */}
			<div className="col-lg-6">
				<label className="form-label d-block">{trans(label)}</label>

				<Upload
					id={UploadId}
					name={UploadId}
					showUploadList={false}
					multiple={false}
					accept=".png,.jpg,.jpeg"
					beforeUpload={(file) => {
						const isValidType = ["image/png", "image/jpeg"].includes(file.type);

						if (!isValidType) {
							toast.info(trans("Only PNG, JPG, and JPEG images are allowed"), {
								autoClose: 800,
							});
							return Upload.LIST_IGNORE; // prevents adding invalid files
						}

						return false; // prevent auto upload
					}}
					onChange={({ fileList }) => {
						const imageFiles = fileList.filter((file) =>
							["image/png", "image/jpeg"].includes(file.type)
						);

						const latest = imageFiles[imageFiles.length - 1];
						addPOI.setFieldValue(UploadId, latest ? [latest] : null);
					}}
				>
					<Button icon={<UploadOutlined />}>{trans("Click to Upload")}</Button>
				</Upload>
			</div>

			{/* Preview */}
			{logoSrc && (
				<div className="flex-between">
					<img
						src={logoSrc}
						alt="logo"
						width={80}
						height={80}
						style={{
							objectFit: "cover",
							borderRadius: 8,
							marginBlock: "8px",
						}}
					/>
					<CloseOutlined onClick={() => addPOI.setFieldValue(UploadId, null)} />
				</div>
			)}
		</div>
	);
}

/* =========================
   POIsLogo Wrapper
========================= */
export default function POIsLogo({ addPOI }) {
	return (
		<>
			<div className="d-flex align-items-center mb-2">
				<p className="fs-16 fw-500 brand-700 text-capitalize me-2">
					{trans("Logos")}
				</p>
				<p style={{ color: "#42526E" }}>({trans("optional")})</p>
			</div>

			<Logo
				label="Contractor"
				InputId="contractorLabel"
				UploadId="contractorLogo"
				addPOI={addPOI}
				value={addPOI?.values?.contractorLabel}
				Logovalue={addPOI?.values?.contractorLogo}
			/>

			<Logo
				label="Customer 1"
				InputId="customer1Label"
				UploadId="customer1Logo"
				addPOI={addPOI}
				value={addPOI?.values?.customer1Label}
				Logovalue={addPOI?.values?.customer1Logo}
			/>

			<Logo
				label="Customer 2"
				InputId="customer2Label"
				UploadId="customer2Logo"
				addPOI={addPOI}
				value={addPOI?.values?.customer2Label}
				Logovalue={addPOI?.values?.customer2Logo}
			/>

			<Logo
				label="Consultant"
				InputId="consultantLabel"
				UploadId="consultantLogo"
				addPOI={addPOI}
				value={addPOI?.values?.consultantLabel}
				Logovalue={addPOI?.values?.consultantLogo}
			/>
		</>
	);
}
